import { getPostById } from "./feed";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const SEED_COMMENTS = [
  { author: "Rhea Kapoor", text: "Insane PR 🔥" },
  { author: "Marcus Chen", text: "Amazing consistency 💪" },
  { author: "Priya Nair", text: "Let's Go!" },
  { author: "Diego Alvarez", text: "Strong work 👏" },
];

// postId -> comments[]
const COMMENTS_STORE = new Map();

function seedComments(postId, commentCount) {
  if (COMMENTS_STORE.has(postId)) return COMMENTS_STORE.get(postId);
  const seeded = SEED_COMMENTS.slice(0, Math.min(commentCount, SEED_COMMENTS.length)).map(
    (c, i) => ({ id: `${postId}-c${i}`, ...c, createdAt: new Date().toISOString() }),
  );
  COMMENTS_STORE.set(postId, seeded);
  return seeded;
}

/** Mirrors `POST /api/feed/:postId/like` (toggle). */
export async function toggleLike(postId, nextLiked) {
  await delay(150);
  const post = getPostById(postId);
  if (post) {
    post.isLiked = nextLiked;
    post.likeCount += nextLiked ? 1 : -1;
  }
  return { isLiked: nextLiked, likeCount: post?.likeCount ?? 0 };
}

/** Mirrors `POST /api/feed/:postId/save` (toggle). */
export async function toggleSave(postId, nextSaved) {
  await delay(150);
  const post = getPostById(postId);
  if (post) post.isSaved = nextSaved;
  return { isSaved: nextSaved };
}

/** Mirrors `GET /api/feed/:postId/comments`. */
export async function fetchComments(postId) {
  await delay(350);
  const post = getPostById(postId);
  return seedComments(postId, post?.commentCount ?? 2);
}

/** Mirrors `POST /api/feed/:postId/comments`. */
export async function addComment(postId, text, author = "You") {
  await delay(250);
  const list = seedComments(postId, 0);
  const comment = {
    id: `${postId}-c${list.length}`,
    author,
    text,
    createdAt: new Date().toISOString(),
  };
  list.push(comment);
  const post = getPostById(postId);
  if (post) post.commentCount += 1;
  return comment;
}

/** Mirrors `POST /api/friends/request/:userId`. */
export async function sendFriendRequest(userId) {
  await delay(300);
  return { userId, status: "pending" };
}
